import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useDeploymentAccess } from "../contexts/useDeploymentAccess";

type SettingsRouteProps = {
  children: ReactNode;
};

export function SettingsRoute({ children }: SettingsRouteProps) {
  const { status } = useDeploymentAccess();

  if (status === "loading") {
    return null;
  }

  if (status === "forbidden") {
    return <Navigate to="/" replace />;
  }

  return children;
}
